var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDismissDocument = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5039 16.3154V11.2812L15.5977 2.375H4.71224C3.66242 2.375 2.65561 2.79204 1.91328 3.53437C1.17094 4.2767 0.753906 5.28352 0.753906 6.33333V30.0833C0.753906 31.1331 1.17094 32.14 1.91328 32.8823C2.65561 33.6246 3.66242 34.0417 4.71224 34.0417H14.9758C14.8531 33.4002 14.7595 32.7392 14.6974 32.0625H4.71224C4.18733 32.0625 3.68392 31.854 3.31276 31.4828C2.94159 31.1116 2.73307 30.6082 2.73307 30.0833V6.33333C2.73307 5.80843 2.94159 5.30502 3.31276 4.93385C3.68392 4.56269 4.18733 4.35417 4.71224 4.35417H15.5977V8.3125C15.5977 9.09986 15.9104 9.85497 16.4672 10.4117C17.0239 10.9685 17.779 11.2812 18.5664 11.2812H22.5247V16.3151C22.8494 16.2594 23.1793 16.2307 23.5135 16.2307C23.8483 16.2307 24.1787 16.2594 24.5039 16.3154ZM5.70182 14.25C5.70182 13.7035 6.14487 13.2604 6.69141 13.2604H12.6289C13.1754 13.2604 13.6185 13.7035 13.6185 14.25C13.6185 14.7965 13.1754 15.2396 12.6289 15.2396H6.69141C6.14487 15.2396 5.70182 14.7965 5.70182 14.25ZM5.70182 20.1875C5.70182 19.641 6.14487 19.1979 6.69141 19.1979H15.5977C16.1442 19.1979 16.5872 19.641 16.5872 20.1875C16.5872 20.734 16.1442 21.1771 15.5977 21.1771H6.69141C6.14487 21.1771 5.70182 20.734 5.70182 20.1875ZM5.70182 26.125C5.70182 25.5785 6.14487 25.1354 6.69141 25.1354H13.6185C14.165 25.1354 14.6081 25.5785 14.6081 26.125C14.6081 26.6715 14.165 27.1146 13.6185 27.1146H6.69141C6.14487 27.1146 5.70182 26.6715 5.70182 26.125Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65771 33.0508H12.6265",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6265 33.0508H15.5952",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5137 20.9792V14.25",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 34.4375L30 26.125",
    stroke: "#3B3B3B",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.4375L21.6875 26.125",
    stroke: "#3B3B3B",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDismissDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dismiss-document.e5a961eb47a6ddbf2a9944ecf10d43b7.svg";